import Login from './pages/Login'
import React from 'react'

const SignUp = (props) => <Login {...props} isSignUp />

export { Login, SignUp }
